import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useAuthContext} from '../context/AuthContext';
import {useFeaturesConfig} from '../context/FeaturesContext';
import {availableRoutes} from './availableRoutes';
import {useAuth} from 'react-oidc-context';

// `PrivateRoute` ajusté pour fonctionner comme un wrapper
const PrivateRoute = ({element: Element}) => {
    const {isBrowsingAllowedTo, rolesLoading} = useAuthContext();
    const {isFeatureEnabled} = useFeaturesConfig();
    const location = useLocation();
    const auth = useAuth();

    if (auth.isLoading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                gap: '16px'
            }}>
                <div>Chargement de keycloak...</div>
                <div style={{fontSize: '12px', color: '#666'}}>
                    Authentification en cours...
                </div>
            </div>
        );
    }

    // Attendre que les privilèges soient chargés avant de continuer
    if (rolesLoading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                gap: '16px'
            }}>
                <div>Chargement des privilèges...</div>
                <div style={{fontSize: '12px', color: '#666'}}>
                    Vérification des autorisations en cours...
                </div>
            </div>
        );
    }

    // Trouve la configuration de la route actuelle
    const currentRoute = availableRoutes.find(route => {
        // Gestion spéciale pour la route catch-all
        if (route.url === '/*') {
            return true; // La route catch-all accepte tout
        }

        // Convertit le pattern de route en regex pour gérer les paramètres dynamiques
        const routePattern = new RegExp('^' + route.url.replace(/:[^\s/]+/g, '[^/]+') + '$');
        return routePattern.test(location.pathname);
    });

    // Vérifie si la route existe et est disponible
    if (!currentRoute?.available) {
        console.log('Route non disponible ou non trouvée:', location.pathname);
        return <Navigate to="/unauthorized" replace/>;
    }

    // Vérifie si les features requises sont activées
    if (currentRoute.featureActivation?.some(feature => !isFeatureEnabled(feature))) {
        console.log('Features requises non activées pour la route:', location.pathname);
        return <Navigate to="/unauthorized" replace/>;
    }

    // Vérifie si l'utilisateur a le droit d'accéder à l'URL actuelle
    if (!isBrowsingAllowedTo(location.pathname)) {
        console.log('Accès non autorisé à l\'URL:', location.pathname);
        return <Navigate to="/unauthorized" replace/>;
    }

    // Rendu du composant cible si toutes les conditions sont satisfaites
    return Element;
};

export default PrivateRoute;
